import { useGet } from '../../HttpClient';
import { Product } from '@app/models';
import { productBaseUrl } from '../BaseUrls';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';

const pillarCode = "tms";
 
export function useGetProduct({ productId }: { productId: string }) {
  const get = useGet(true, pillarCode);
  const getProduct = async (productId: string) => await get<Product>(`${productBaseUrl}/products/${productId}?includeBrandDetails=true`);
  return useQueryWithErrorHandling({
    queryKey: ['product', productId],
    queryFn: async () => await getProduct(productId),
    enabled: !!productId,
  });
}
